<style scoped>
    @import url("../../../styles/contadorAguaPage/v3/grupos.scss");
</style>

<template>
    <div class="box_consumidor">

        <div class="label" v-if="flagStrSelect == ''"><span class="ml-2">Malha</span></div>
        
        <div class="boxTitGeralConsumidor" v-if="flagStrSelect == ''">
            <span class="ml-2" v-if="!flagEditNome">{{ nomeA }}</span>

            <v-form v-if="!flag_loading_A && flagEditNome" class=""
            ref="form"
            v-model="valid"
            lazy-validation
            >
                <v-text-field 
                color="orange"
                v-model="nomeMalhaEditing"
                :rules="nameRules"
                :label="nomeA"
                required
                style="width: 300px;"
                ></v-text-field>
            </v-form>

            <v-btn color="success" x-small v-if="flagEditNome" @click="changeName()">Atualizar nome</v-btn>
        
            <span v-if="flagError_A && !flag_loading_A"
            :style="{'margin-top':'10px','color':'red','font-size':'0.8rem'}">
                {{ msgError_A }}
            </span>
        </div>

        <v-dialog v-model="flagDialogC" max-width="250px">
            <div class="">
                <!-- O componente form -->
                <DialogC :t="'NOVO NOME'" :icon="'mdi-alert'" :msgFromInput="'Escolha outro nome ainda não existente no sistema.'"
                @fromInput="desableDialog($event)" :flagStrTipoDialog="'dialogC'"
                />
            </div>
        </v-dialog>

        <!-- DESATIVAÇÃO -->
        <v-dialog v-model="flagDialogB" max-width="250px">
            <div class="">
                <!-- O componente form -->
                <DialogB :flagStrTipoDialog="'des'" :t="'Desativar malha'" :icon="'mdi-alert'" 
                :idMalha="idMalha"
                @fromDes="desableDialog($event)" 
                />
            </div>
        </v-dialog>

        <!-- REATIVAÇAO -->
        <v-dialog v-model="flagDialogD" max-width="250px">
            <div class="">
                <!-- O componente form -->
                <DialogB :flagStrTipoDialog="'reat'" :t="'Reativar malha'" :icon="'mdi-alert'" 
                :idMalha="idMalha"
                @fromReat="desableDialog($event)" 
                />
            </div>
        </v-dialog>

        <!-- Selecionar btn -->
        <div class="edits">
            <v-btn small class="mt-1" v-if="!flagEditNome" @click="flagEditNome = true">
                <span>Editar nome malha</span>
                <v-icon class="ml-1">mdi-square-edit-outline</v-icon>
            </v-btn>

            <v-btn outlined color="red" small class="mt-1 ml-1" v-if="!flagEditNome && !flagDes"
            @click="flagDialogB = true">
                <span>Desativar malha</span>
                <v-icon class="ml-1">mdi-water-remove-outline</v-icon>
            </v-btn>

            <v-btn outlined color="green" small class="mt-1 ml-1" v-if="!flagEditNome && flagDes"
            @click="flagDialogD = true">
                <span>Reativar malha</span>
                <v-icon class="ml-1">mdi-water-plus-outline</v-icon>
            </v-btn>
        </div>

        <!--<v-btn block small class="mt-1" v-if="flagStrSelect == '' && !flagEditNome" @click="flagEditNome = true">
            <span>Editar nome malha</span>
            <v-icon class="ml-1">mdi-square-edit-outline</v-icon>
        </v-btn>-->

        <!-- Caixa de diálogo: input string -->
        <v-dialog v-model="flagDialog" max-width="250px">
            <div class="">
                <!-- O componente form -->
                <DialogA :t="'Novo Grupo'" :icon="'mdi-home-group'" 
                @fromInput="desableDialog($event)" 
                />
            </div>
        </v-dialog>

        <div class="titGeral mt-4">
            <v-icon :style="{'color':'rgb(31,122,177)'}">mdi-home-group</v-icon>
            <span class="ml-2">Grupos</span>
        </div>

        <!-- NOVO GRUPO -->
        <v-btn block small class="mt-4" @click="flagDialog = true">
            <span>Adicionar novo grupo</span>
            <v-icon class="ml-1">mdi-plus-box-outline</v-icon>
        </v-btn>

        <!-- PAINEL GRUPOS -->
        <div class="label mt-2"><span class="ml-2">Todos os grupos</span></div>

        <div class="painelGeralConsumidor">

            <div class="headersClasses" :style="{'border':'1px solid rgba(7,46,79,0.8)'}">
                <div class="hCard">Nome</div>
                <div class="hCard">Medidores de Entradas</div>
                <div class="hCard">Medidores de Saídas</div>
                <div class="hCard">Status</div>
                <div class="hCard" :style="{'justify-self':'flex-end'}">Ação</div>
            </div>

            <div class="boxLi">
                <div class="liClasses" v-for="(el,r) in liClasses" :key="r"
                :style="{'background':el.b}"
                @mouseover="changeBtn(r,'on')"
                @mouseleave="changeBtn(r,'off')"
                @click="callGrupo(r)"
                >
                    <div class="hCard">{{ el.t }}</div>
                    <div class="hCard">{{ el.z }}</div>
                    <div class="hCard">{{ el.m }}</div>
                    <div class="hCard">{{ el.status }}</div>

                    <v-icon class="hCard" :style="{'justify-self':'flex-end'}">mdi-square-edit-outline</v-icon>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
//import Classe from './Classe'
//import Medidor from './Medidor'
//import ZMC from './ZMC'

import DialogA from './DialogA'
import DialogB from './DialogB'
import DialogC from './DialogC'

export default {

    props:['idMalha'],
    //props: ['id'], // O Vue Router injeta o ID aqui

    components:{DialogA,DialogB,DialogC}, // Classe,Medidor,ZMC,

    data() {
        return {
            //
            liClasses:[
                //{'t':'Grupo sem nome','m':3,'z':0,'b':''},
                //{'t':'Laboratório','m':3,'z':0,'b':''},
            ],
            idGrupo:0, // enviado via props para ativar o grupo selecionado.

            nomeA:'UPinC Lda', // nome da malha

            flagStrSelect:'',

            // edit nome
            flagEditNome:false,
            nomeMalhaEditing:'',
            valid: false, // btn 'entrar' inicia desabilitado.
            nameRules: [
                v => !!v || 'Preenchimento obrigatório',
            ],
            flag_loading_A:false,
            flagError_A:false,
            msgError_A:'Nome inválido',

            // dialog
            flagDialog:false,
            flagDialogB:false, // desativação malha
            flagDialogC:false,
            flagDialogD:false, // reativação malha

            flagDes:false, // indicar status da malha. Init ativada por padrão.
        }
    },

    methods:{
        // -- CALL PAGE via flag local.
        callGrupo(index) { 
            //console.log('Grupo requisitado: ', this.liClasses[index].t)

            var idGrupo = index
            this.$store.state.jTmpMalha.idGrupo = index
            this.$store.state.jTmpMalha.grupo = this.liClasses[index].t
            this.flagStrSelect = 'grupo'

            //var idMalhaSelected = this.$store.state.jTmpMalha.idMalha // via store.
            var idMalha = this.idMalha // via props rota aninhada.
            //console.log('Grupo [idMalha]: ', idMalha)

            this.$router.push(`/ca/malhas/${idMalha}/grupos/${idGrupo}/medidores`);
        },

        changeBtn(index,strFlag) { 
            if (strFlag == 'on') { this.liClasses[index].b = 'rgb(247,215,46)' }
            else { 
                if (this.liClasses[index].status == 'Desativado') { 

                    this.liClasses[index].b = 'rgba(255,0,0,0.3)' 
                }
                else { 
                    
                    this.liClasses[index].b = ''
                }
            }
        },
        changeFlagStr(flagStr) {
            this.flagStrSelect = flagStr
        },

        changeName() {
            this.flag_loading_A = true // iniciar loading...

            if (this.nomeMalhaEditing.length >= 2) {

                if (this.$refs.form.validate()) {

                    //console.log('input ok')

                    this.flag_loading_A = false // desabilitar loading
                    this.flagError_A = false // reset flag error

                    this.nomeA = this.nomeMalhaEditing
                    this.nomeMalhaEditing = '' // reset var input

                    // update malha final store (idMalha via props router)
                    this.$store.state.liMalhas[this.idMalha].malha = this.nomeA

                    this.flagEditNome = false // desable edit.
                }

            } else {
                
                this.flag_loading_A = false // desabilitar loading
                this.flagError_A = true

                //this.flagEditNome = false // desable edit.
                return
            }
        },

        desableDialog(flagLi) { 

            this.flagDialog = flagLi[0]
            var flagStrTipoDialog = flagLi[2] // 'IN' or 'OUT' rcv from emit OR 'del' or 'dialogC'

            if (flagStrTipoDialog == 'dialogC') {
                this.flagDialogC = false // dasabilitar alerta de input errado.
                return
            }

            if (flagStrTipoDialog == 'des' || flagStrTipoDialog == 'reat') { 
                this.flagDialogB = false

                // redirecionar para a hierarquia anterior.
                //const r = this.$route.params // Captura os parâmetros da rota atual
                //console.log('routeParams: ',r)
                var rotaPush = `/ca/malhas`
                //console.log('rotaPush: ',rotaPush)
                this.$router.push(rotaPush)

                return
            } // -- op no component dialogB.

            // -- verificar unicidade do nome a ser inputado. (o nome deve ser único).
            //console.log('verificando nome...')
            var novoNome = flagLi[1]
            // -- verificar todo o db.
            var malhas = this.$store.state.liMalhas
            var qntMalhas = malhas.length
            var grupos = []
            var qntGrupos = 0
            var saidas = []
            var entradas = []
            var qntOUT = 0 // int
            var qntIN = 0 // int
            var m = 0
            while (m < qntMalhas) {
                if (malhas[m].malha == novoNome) { this.flagDialogC = true; return }
                qntGrupos = malhas[m].grupos.length // int
                grupos = malhas[m].grupos // list
                var c = 0
                while (c < qntGrupos) {
                    if (grupos[c].grupo == novoNome) { this.flagDialogC = true; return }
                    qntOUT = grupos[c].saidas.length // int
                    qntIN = grupos[c].entradas.length // int
                    saidas = grupos[c].saidas // list
                    entradas = grupos[c].entradas // list
                    var vm = 0
                    while (vm < qntOUT) {
                        if (saidas[vm].nome == novoNome) { this.flagDialogC = true; return }
                        vm++
                    }
                    var vz = 0
                    while (vz < qntIN) {
                        if (entradas[vz].nome == novoNome) { this.flagDialogC = true; return }
                        vz++
                    }
                    c++
                }
                m++
            }

            var novoEl = {
                'id':this.liClasses.length,
                'grupo':novoNome,
                'status':'ativo',
                'entradas':[],
                'saidas':[]
            }
            //console.log('Novo grupo: ', novoEl)
            //console.log('grupos[qualquer].entradas.length [init grupos]: ', novoEl.entradas.length)

            //this.liClasses.push(novoEl) // input novo nome string. (versão dev)
            //this.$store.state.liMalhas[this.$store.state.jTmpMalha.idMalha].grupos.push(novoEl) // (versão teste local)
            this.$store.state.liMalhas[this.idMalha].grupos.push(novoEl)
            //console.log('this.$store.state.liMalhas[this.idMalha].grupos: ', this.$store.state.liMalhas[this.idMalha].grupos)

            this.init() // remontar página com novo grupo adiconado.
        },

        init() {
            //var grupos = this.$store.state.liMalhas[this.$store.state.jTmpMalha.idMalha].grupos // list
            var grupos = this.$store.state.liMalhas[this.idMalha].grupos // list com id via props router
            //console.log('grupos [init grupos]: ', grupos)
            //console.log('grupos.length [init grupos]: ', grupos.length)

            // verif status malha atual.
            // Se desativada, então flagDes = true | flagDes = false (default/init)
            if (this.$store.state.liMalhas[this.idMalha].status == 'Desativado') { this.flagDes = true }
            //console.log('this.flagDes: ',this.flagDes)

            var tmpBackColor = ''
            var liTmp = []
            var c = 0
            while (c < grupos.length) {
                //console.log('c [init grupos]: ', c)

                if (grupos[c].status == 'Desativado') { tmpBackColor = 'rgba(255,0,0,0.3)' }
                else { tmpBackColor = '' }

                var elGrupoLocal = {
                    'iddCl':grupos[c].id,
                    't':grupos[c].grupo, // nome do grupo
                    'm':grupos[c].saidas.length,
                    'z':grupos[c].entradas.length,
                    'status':grupos[c].status,
                    'b':tmpBackColor
                }

                liTmp.push(elGrupoLocal) // input grupo em uma malha

                c++
            }
            this.liClasses = liTmp

            //this.nomeA = this.$store.state.jTmpMalha.malha
            this.nomeA = this.$store.state.liMalhas[this.idMalha].malha
        },
    },

    created() {
        window.scrollTo(0,0)

        this.init()
    }
}
</script>